export const maxResolution = 3840;
export const minResolution = 200;
